import { Completion } from '@codemirror/autocomplete';
import { schemaCompletionSource, SQLDialect } from '@codemirror/lang-sql';

export interface Column {
  name: string;
  type: string;
}

export interface Table {
  name: string;
  columns: Column[];
}

export interface SqlSchema {
  tables: Table[];
}

export default function personaSqlDatasourceCompletionSource(
  dialect: SQLDialect,
  sqlSchema: SqlSchema,
) {
  const schema: { [table: string]: (string | Completion)[] } = {};

  for (const table of sqlSchema.tables) {
    for (const column of table.columns) {
      if (!schema[table.name]) {
        schema[table.name] = [];
      }
      schema[table.name].push(column.name);
    }
  }

  // Convert this to something @codemirror/lang-sql understands
  return schemaCompletionSource({
    dialect,
    schema,
  });
}
